import {Component, Input, OnChanges, ViewChild} from '@angular/core';
import {FileService} from '../../../../services/file.service';
import {LoadingService} from '../../../../services/loading.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {SuperMarketRefrigeratorBudgetService} from '../../../../services/super-market-refrigerator-budget.service';

@Component({
  selector: 'app-super-market-budget-second-step',
  templateUrl: './super-market-upload-second-step.component.html'
})
export class SuperMarketUploadSecondStepComponent implements OnChanges {
  @Input() addresses: any[];
  @Input() file: any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];

  constructor(private fileService: FileService,
              private loadingService: LoadingService,
              private superMarketBudgetService: SuperMarketRefrigeratorBudgetService,
              private toastMessagesService: ToastMessagesService) {
    this.dataSource = new MatTableDataSource();
    this.displayedColumns = [
      'hqName',
      'materialId',
      'category',
      'led',
      'initialBudget'
    ];
  }

  public ngOnChanges(): void {
    this.dataSource = new MatTableDataSource(this.addresses);
    this.paginator._intl.itemsPerPageLabel = 'Εγγραφές Ανά Σελίδα';
    this.paginator._intl.firstPageLabel = 'Πρώτη Σελίδα';
    this.paginator._intl.lastPageLabel = 'Τελευταία Σελίδα';
    this.paginator._intl.nextPageLabel = 'Επόμενη Σελίδα';
    this.paginator._intl.previousPageLabel = 'Προηγούμενη Σελίδα';

    this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 από ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} από ${length}`;
    };
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public async submitProcess(): Promise<any> {
    try {
      this.loadingService.show();
      const formData: FormData = new FormData();
      formData.append('file', this.file.file, this.file.file_name);
      const file: any = await this.fileService.uploadFile(`super_market_budget/file`, formData);
      const body = {
        data: this.addresses,
        fileID: file.id
      };
      await this.superMarketBudgetService.insertSuperMarketRefrigeratorBudget(body);
      this.toastMessagesService.toastMessages(`Η μεταφόρτωση ολοκληρώθηκε με επιτυχία`);
    } catch (error) {
      this.toastMessagesService.toastErrorMessage(error.error.message);
    } finally {
      this.loadingService.hide();
    }
  }
}
